import { z } from 'zod';
/**
 * Payloads of the `recipe-shares` Edge Function.
 *
 * Free of any relative import: the function loads this file, and neither Deno
 * nor the Supabase CLI — which mounts every file a function imports when the
 * stack starts — resolves the `.js` specifiers TypeScript requires.
 */
/** Payload creating a public link to one of the family's recipes. */
export const CreateRecipeShareSchema = z.object({
    recipe_id: z.string().uuid(),
});
/** Filter of the link list: one recipe's links, or the whole family's. */
export const RecipeShareListQuerySchema = z.object({
    recipe_id: z.string().uuid().optional(),
});
//# sourceMappingURL=recipe-share-requests.js.map